import { Stack, Container, useMediaQuery, useTheme } from "@mui/material";
import { ReactElement } from "react";
import { MoreButton } from "./MoreButton";
import { Parentheses } from "./Parentheses";

type Props = {
  title?: string;
  children: ReactElement;
  background?: string;
  image?: string;
  moreHref?: string;
  reverse?: boolean;
};

export const TopAbout = ({
  title,
  children,
  background,
  image,
  moreHref,
  reverse,
}: Props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <Stack
      sx={{
        background: background ? background : "",
      }}
    >
      <Container sx={{ position: "relative" }}>
        <Stack
          direction={reverse ? "row-reverse" : "row"}
          justifyContent="space-between"
          flexWrap="wrap"
        >
          <Stack
            width={image ? (isMobile ? "100%" : "56%") : "100%"}
            height="fit-content"
          >
            <Parentheses title={title}>{children}</Parentheses>
            {moreHref && !isMobile ? (
              <Stack alignItems={"end"} marginTop={4} paddingRight={2}>
                <MoreButton href={moreHref} />
              </Stack>
            ) : null}
          </Stack>
          {image ? (
            <Stack
              width={isMobile ? "60%" : "37%"}
              textAlign={"center"}
              margin={isMobile ? "20px auto" : 0}
            >
              <img src={image} alt="" />
            </Stack>
          ) : null}
          {moreHref && isMobile ? (
            <Stack margin="20px auto 0">
              <MoreButton href={moreHref} />
            </Stack>
          ) : null}
        </Stack>
      </Container>
    </Stack>
  );
};
